<template>
	<div class="banner-card-wrapper">
		<div class="banner">
			<el-image style="width: 100%; height: 100%" :src="getCoverPicture" fit="cover" lazy></el-image>
			<div v-if="item.isTop" class="is-top">{{ $t('enterprise.top-post') }}</div>
		</div>
		<div class="content mt-12 text-overflow2">{{ item.title }}</div>
		<div class="date mt-8">{{ formatDateFn(item.stime) }}</div>
	</div>
</template>

<script setup>
import dayjs from 'dayjs';
import { computed } from 'vue';
import { useCommonData } from '@/hooks';
import EMPTY_NEWS_COVER from '@/assets/images/empty_news_cover.png';
import EMPTY_EVENT_COVER from '@/assets/images/empty_event_cover.png';

const props = defineProps({
	item: {
		type: Object,
		default() {
			return {};
		}
	},
	emptyText: {
		type: String,
		default: ''
	},
	bannerType: {
		type: String,
		default: ''
	}
});

const formatDateFn = date => {
	return dayjs(date).format('YYYY-MM-DD');
};

const MODULE_DEFAULT_COVERS = {
	'news': EMPTY_NEWS_COVER,
	'event': EMPTY_EVENT_COVER
};
const { getColumnData } = useCommonData();
const getCoverPicture = computed(() => {
	if (props.item?.logo43) return props.item.logo43;
	// 投关活动 不展示配置的默认封面
	if (props.bannerType === 'event') return MODULE_DEFAULT_COVERS['event'];

	const { coverPicture, coverPictureSwitch } = getColumnData.value;
	const defaultCover = coverPictureSwitch
		? coverPicture || MODULE_DEFAULT_COVERS[props.bannerType]
		: MODULE_DEFAULT_COVERS[props.bannerType];

	return defaultCover;
});
</script>

<style lang="less" scoped>
.banner-card-wrapper {
	width: 100%;

	.banner {
		height: 189px;
		cursor: pointer;
		position: relative;

		/deep/.el-image__inner {
			transition: all 0.18s ease-in-out;
		}
		&:hover {
			/deep/.el-image__inner {
				transform: scale(1.08);
			}
		}
		.is-top {
			position: absolute;
			top: 0;
			right: 0;
			padding: 0 10px;
			height: 20px;
			line-height: 20px;
			font-size: 12px;
			font-weight: 400;
			color: #ffffff;
			border-radius: 0 0 2px 2px;
			background: #f23d3d;
		}
	}
	.content {
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #1d2129;
		// height: 48px;
	}
	.date {
		font-size: 12px;
		font-weight: 400;
		line-height: 18px;
		color: #4e5969;
	}
}
</style>
